const BASE_URL = 'https://us-central1-flexyswap.cloudfunctions.net';

async function request(path, { method = 'POST', body, headers } = {}) {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(headers || {}),
    },
  };

  if (body && method !== 'GET') {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(`${BASE_URL}${path}`, options);
  const text = await response.text();

  let parsed;
  try {
    parsed = text ? JSON.parse(text) : {};
  } catch (err) {
    console.error('Failed to parse Firebase Functions response:', text);
    throw new Error('Unexpected response from server');
  }

  if (!response.ok) {
    const message =
      parsed?.error || parsed?.message || `Request failed with ${response.status}`;
    throw new Error(message);
  }

  return parsed;
}

const firebaseFunctionsService = {
  createCustomer(email, name, userId) {
    return request('/createCustomerHTTP', {
      body: { email, name, userId },
    });
  },

  async checkAccountStatus(userId, authToken = null) {
    const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
    return request(`/checkAccountStatusHTTP?userId=${userId}`, {
      method: 'GET',
      headers,
    });
  },

  async createPaymentIntent(amount, currency = 'usd', metadata = {}, customerId = null) {
    const response = await request('/createPaymentIntent', {
      body: { data: { amount, currency, metadata, customerId } },
    });
    return response.result || response;
  },

  confirmPaymentIntent(paymentIntentId, userId, amount) {
    return request('/confirmPaymentIntentHTTP', {
      body: { paymentIntentId, userId, amount },
    });
  },

  createConnectAccount(email, userId) {
    return request('/createConnectAccountHTTP', {
      body: { email, userId },
    });
  },

  deleteConnectAccount(accountId, userId) {
    return request('/deleteConnectAccountHTTP', {
      body: { accountId, userId },
    });
  },

  createAccountLink(accountId) {
    return request('/createAccountLinkHTTP', {
      body: { accountId },
    });
  },

  async createTransfer(amount, destinationAccount, userId, authToken = null) {
    const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
    return request('/createTransferHTTP', {
      body: { amount, destinationAccount, userId, authToken },
      headers,
    });
  },

  confirmDeliveryPayment(
    requestId,
    payerId,
    receiverId,
    amount,
    fee,
    total,
    currency,
    itemTitle,
    authToken,
    tip = 0,
    collectionName = 'requests',
  ) {
    return request('/confirmDeliveryPaymentHTTP', {
      body: {
        requestId,
        payerId,
        receiverId,
        amount,
        fee,
        total,
        currency,
        itemTitle,
        authToken,
        tip,
        collectionName,
      },
    });
  },

  async getSavedPaymentMethods(customerId, userId, authToken = null) {
    const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
    const response = await request('/getSavedPaymentMethodsHTTP', {
      body: { customerId, userId, authToken },
      headers,
    });
    return response;
  },

  async deletePaymentMethod(paymentMethodId, customerId, userId, authToken = null) {
    const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
    const response = await request('/deletePaymentMethodHTTP', {
      body: { paymentMethodId, customerId, userId, authToken },
      headers,
    });
    return response;
  },
};

export default firebaseFunctionsService;


